import Vue from 'vue'

import mobile from 'is-mobile'

Vue.prototype.$appName = 'Labotist Web Application'
Vue.prototype.$timezone = new Date().getTimezoneOffset()

if (location.hostname === 'labotist.com') {
  Vue.prototype.$apiUrl = 'https://webapi.labotist.com/'
  Vue.prototype.$s3BucketUrl = 'https://s3-ap-southeast-1.amazonaws.com/labotist-prod/'
  Vue.prototype.$payment_mode = 'LIVE'
  Vue.prototype.$razorpay_key = 'rzp_live_iBU7RZx7cl20N9'
  Vue.prototype.$blogRedirectUrl = 'https://labotist.com/lab'
  Vue.prototype.$signupUrl = 'https://labotist.com/referral/signup/'
} else if (location.hostname === 'stage.labotist.com') {
  Vue.prototype.$apiUrl = 'https://webapi-stage.labotist.com/'
  Vue.prototype.$s3BucketUrl = 'https://s3-ap-southeast-1.amazonaws.com/labotist-stage/'
  Vue.prototype.$payment_mode = 'TEST'
  Vue.prototype.$razorpay_key = 'rzp_test_3D5exVpKm54qdc'
  Vue.prototype.$blogRedirectUrl = 'https://stage.labotist.com/lab'
  Vue.prototype.$signupUrl = 'https://stage.labotist.com/referral/signup/'
} else if (location.hostname === 'dev.labotist.com') {
  Vue.prototype.$apiUrl = 'https://dev-webapi.labotist.com/'
  Vue.prototype.$s3BucketUrl = 'https://s3-us-west-2.amazonaws.com/devlab/'
  Vue.prototype.$payment_mode = 'TEST'
  Vue.prototype.$razorpay_key = 'rzp_test_3D5exVpKm54qdc'
  Vue.prototype.$blogRedirectUrl = 'https://dev.labotist.com/lab'
  Vue.prototype.$signupUrl = 'https://dev.labotist.com/referral/signup/'
} else {
  Vue.prototype.$apiUrl = 'http://13.201.212.41:3000/'
  Vue.prototype.$s3BucketUrl = 'https://s3-us-west-2.amazonaws.com/devlab/'
  Vue.prototype.$payment_mode = 'TEST'
  Vue.prototype.$razorpay_key = 'rzp_test_3D5exVpKm54qdc'
  Vue.prototype.$blogRedirectUrl = 'http://13.201.212.41:3000/lab'
  Vue.prototype.$signupUrl = 'http://13.201.212.41:3000/referral/signup/'
}

// Payment Charges
Vue.prototype.$phlebotomistFee = 0 // 100
Vue.prototype.$labotistDiscount = 150
Vue.prototype.$phlebotomyFeeWaiver = 0 // 100
Vue.prototype.$waiverDiscountApplyFee = 0 // 1000
Vue.prototype.$GSTFee = '0' // 18 percentage
Vue.prototype.$defaultPincode = '600017' // 18 percentage
Vue.prototype.$cashPayment = false
Vue.prototype.$fuzzyDistance = 100

global.successId = 0

Vue.prototype.$IsMobile = mobile()
Vue.prototype.$WebView = false
Vue.prototype.$WebViewBridge = undefined
Vue.prototype.$IsWebViewIos = false
Vue.prototype.$IsWebViewAndroid = false
if (mobile()) {
  try {
    if (WebViewBridge) {
      Vue.prototype.$WebView = true
      Vue.prototype.$WebViewBridge = WebViewBridge
      var standalone = window.navigator.standalone,
      userAgent = window.navigator.userAgent.toLowerCase(),
      safari = /safari/.test( userAgent ),
      ios = /iphone|ipod|ipad/.test( userAgent );
      if(ios) {
        if ( !standalone && !safari ) {
          Vue.prototype.$IsWebViewIos = true
        } else {
          Vue.prototype.$IsWebViewAndroid = true
        }
      } else {
        Vue.prototype.$IsWebViewAndroid = true
      }
    }
  } catch (err) {
    console.log('Browser')
    let i = 0, j = false
    var tmt = setInterval(function () {
      try {
        if (i >= 30) {
          clearInterval(tmt)
        }
        if (WebViewBridge && !j) {
          // alert(i)
          Vue.prototype.$WebView = true
          Vue.prototype.$WebViewBridge = WebViewBridge
          var standalone = window.navigator.standalone,
          userAgent = window.navigator.userAgent.toLowerCase(),
          safari = /safari/.test( userAgent ),
          ios = /iphone|ipod|ipad/.test( userAgent );
          if(ios) {
            if ( !standalone && !safari ) {
              Vue.prototype.$IsWebViewIos = true
            }
          } else {
            Vue.prototype.$IsWebViewAndroid = true
          }
          j = true
          clearInterval(tmt)
        }
      }catch (er) {
        // console.log('Checking browser type')
      }
      i++
    }, 1000)
  }
}

export default {
  name: 'Config',
  data () {},
  mixins: {
    created: function () {
      this.$config = Vue.prototype
    }
  },
  IsMobile: mobile()
}



// WEBPACK FOOTER //
// ./src/config.js